import React from 'react'
import { useState ,useEffect} from 'react'
import Header from '../common/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer'
import { useDispatch } from 'react-redux'
import { notifyError } from '../helper/Toaster'
import { deleteAuthToken } from '../../utils/helper'
import { getAllPapersAdmin } from '../../requests'
import SearchableDropdown from '../common/SearchableDropdown'
import { formatDateLong } from '../helper/formatters'
import Nodata from '../common/Nodata'


const Papers = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
    const {teacher_name, school_name,user_id} = useLocation().state



    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)
    const [totalCount, setTotalCount] = useState(0)
    const [exam_names, setExamNames] = useState([])
    const [subjects, setSubjects] = useState([])
    const [grades, setGrades] = useState([])
    const [exam_name, setExamName] = useState("")
    const [subject, setSubject] = useState("")
    const [grade, setGrade] = useState("")
    const [papers, setPapers] = useState([])
    const [noData, setNoData] = useState(false)

    const getAllPapers = async (pageVal) => {
      if(!user_id) {
        return;
      }
      dispatch(startLoader())
      try {
        const response = await getAllPapersAdmin({page: pageVal, limit: limit, user_id: user_id, subject: subject == 'All subjects' ? '' : subject, grade: grade == 'All grades' ? '' : grade})
        
        if(response.status == 200){
          setPapers(response.data.data)
          if(response.data.data.length == 0){
            setNoData(true)
          }
          else{
            setNoData(false)
          }
          setTotalCount(response.data.totalCount)
          setExamNames(['All exams',...response.data.exam_names])
          setSubjects(['All subjects',...response.data.subjects])
          setGrades(['All grades',...response.data.grades])
        }
      } catch (error) {
        if(error?.response?.status == 403){
          notifyError(error?.response?.data?.error ||"Your session has expired. Please log in again.")
          deleteAuthToken()
          navigate('/login')
          return;
        }
        notifyError(error?.response?.data?.error || "Something went wrong");
      } finally {
        dispatch(stopLoader())
      }
    }

    useEffect(() => {
      setPage(1)
      getAllPapers(1)
    }, [user_id, grade, subject])


    useEffect(() => {
      getAllPapers(page)
    }, [page])
      
  return (
    <div className='page-main'>
    <Header name = {["School Management","Teachers","Papers"]} />
    <div className='tm-main'>
        <div className="overview-head">
            <div className="overview-head-left">Papers evaluated by {teacher_name}

            <div style={{fontSize: '14px', color: '#6B7280'}}>{school_name}</div>
            </div>

            <div className="overview-head-right">

              <SearchableDropdown
                options={[...grades]}
                selected={grade}
                setSelected={(e) => setGrade(e)}
                color="#E5E7EB"
                placeHolder='Enter grade'
              />
              <SearchableDropdown
                options={[...subjects]}
                selected={subject}
                setSelected={(e) => setSubject(e)}
                color="#E5E7EB"
                placeHolder='Enter subject'
              />
            </div>
            


        </div>

        <div className="ai-fd-table">
      
    <div className="ai-fd-table-head">
      <div className="ai-fd-head-cell" style={{ width: "20%" }}>
        Student Name
      </div>

      <div className="ai-fd-head-cell" style={{ width: "10%" }}>Marks</div>
     
      <div className="ai-fd-head-cell" style={{ width: "10%" }}>Grade</div>
      <div className="ai-fd-head-cell" style={{ width: "10%" }}>
        Roll No
      </div>
      <div className="ai-fd-head-cell" style={{ width: "20%" }}>
       Subject
      </div>
      <div className="ai-fd-head-cell" style={{ width: "15%" }}>
       Exam Name
      </div>
     

      <div className="ai-fd-head-cell" style={{ width: "15%" }}>
        Uploaded On
      </div>
   
     
    </div>
    {noData && <Nodata message="No papers found" />}
        {papers.length > 0 &&
        papers.map((e, i) => (
        <div key={i} className="ai-fd-table-row">
          <div className="ai-fd-row-cell" style={{ width: "20%" }}>
            {e.student_name}
          </div>
          <div className="ai-fd-row-cell" style={{ width: "10%" }}>
            {e.marks_obt }/{e.marks_total}
          </div>
         
          <div className="ai-fd-row-cell" style={{ width: "10%" }}>
            {e.grade}
          </div>
          <div className="ai-fd-row-cell" style={{ width: "10%" }}>
            {e.student_rollno}
          </div>
          <div className="ai-fd-row-cell" style={{ width: "20%" }}>
            {e.subject}
          </div>
          <div className="ai-fd-row-cell" style={{ width: "15%" }}>
            {e.exam_name}
          </div>
         
          <div className="ai-fd-row-cell" style={{ width: "15%" }}>
            {formatDateLong(e.created_at)}
          </div>
          
          
          
        </div>
      ))}
  </div>
  <div className="di-flex" style = {{width: '100%'}}>
      <div style={{ color: "#6B7280" }}>
        {" "}
        Showing {((page-1) * limit )+ 1} to {papers.length + (page - 1) * limit} out of {totalCount}{" "}
        items{" "}
      </div>
      <div
        className="di-flex"
        style={{ justifyContent: "end", gap: "10px" }}
      >
        <button
          disabled={page == 1}
          className="my-btn"
          style={{
            backgroundColor: "#E0F5FE",
            color: "#01A7DE",
            opacity: page == 1 ? 0.4 : 1,
          }}
          onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
        >
          Previous
        </button>
        <button
          disabled={papers.length + (page - 1) * limit >= totalCount}
          className="my-btn"
          style={{
            backgroundColor: "#E0F5FE",
            color: "#01A7DE",
            opacity:
              papers.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
          }}
          onClick={() => setPage((p) => (papers.length ? p + 1 : p))}
        >
          Next
        </button>
      </div>
    </div>


    </div>
   
</div>
  )
}

export default Papers